class RevealOnScroll extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    const reduced = document.documentElement.classList.contains('motion-reduced') || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || !('IntersectionObserver' in window)) { this.dataset.revealed = 'true'; return; }
    this.initialized = true;
    document.documentElement.classList.add('reveal-ready');
    this.observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (entry.isIntersecting) { this.dataset.revealed = 'true'; this.observer.disconnect(); }
    }), { threshold: 0.12 });
    this.observer.observe(this);
  }
  disconnectedCallback() { this.observer?.disconnect(); this.initialized = false; }
}
if (!customElements.get('reveal-on-scroll')) customElements.define('reveal-on-scroll', RevealOnScroll);
